import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/hy-logo.png";
import Loading from "../components/Loading";
import "./Login.css";

function fetchWithTimeout(url, options = {}, ms = 2000) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), ms);
  return fetch(url, { ...options, signal: controller.signal })
    .finally(() => clearTimeout(id));
}

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [backendDown, setBackendDown] = useState(sessionStorage.getItem("backendDown") === "1");

  useEffect(() => {
    if (!error) return;

    let alive = true;

    const check = async () => {
      try {
        const res = await fetchWithTimeout("/account/health/", { method: "GET" }, 1500);
        if (!res.ok) throw new Error();
        if (!alive) return;

        sessionStorage.removeItem("backendDown");
        setBackendDown(false);
        if (error === "서버에 연결 할 수 없습니다." || error === "서버 오류 발생.") setError("");
      } catch {
        if (!alive) return;

        sessionStorage.setItem("backendDown", "1");
        setBackendDown(true);
        if (error) setError("서버에 연결 할 수 없습니다.");
      }
    };

    check();
    const t = setInterval(check, 3000); // 3초마다
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, [error]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch("/account/login/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const data = await response.json().catch(() => ({}));
      const remain = Number.isFinite(Number(data?.axes_remaining)) ? Number(data.axes_remaining) : null;

      if (response.ok && data.success) {
        localStorage.setItem("authToken", data.access);
        localStorage.setItem("refreshToken", data.refresh);
        localStorage.setItem("username", username);

        // const favKey = `favorites_${username}`;
        // localStorage.setItem(favKey, JSON.stringify([]));

        sessionStorage.removeItem("backendDown");
        setBackendDown(false);

        navigate("/dashboard");
      } else {
        const suffix = remain === null ? "" : ` (${remain}회 남음)`;
        setError(`계정 확인.${suffix}`);
      }
    } catch (err) {
      setError("서버 오류 발생.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Loading active={loading} />

      <div className="container">
        <div className="logo-container">
          <img src={logo} alt="로고" className="logo" />
        </div>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>아이디:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>비밀번호:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <p className="error-message">{error || "\u00A0"}</p>
          <button type="submit" className="button" disabled={backendDown || loading}>로그인</button>
        </form>
      </div>

      <div className="login-version">
        {`Server V1.3.1`}
      </div>
    </div>
  );
}

export default Login;
